import OpenIntercomLink from "./open-intercom-link";
import React from "react";
import TournamentChatsFeedItem from "./tournament-chats-feed-item";
import GameManagerAvatar from "./game-manager-avatar";

export default class TournamentChatsFeed extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.refs.chatList.scrollTop = this.refs.chatList.scrollHeight;
  }

  componentDidUpdate() {
    this.refs.chatList.scrollTop = this.refs.chatList.scrollHeight;
  }

  render() {
    var { currentUserId, onPostChat, tournament, tournamentChats, users } = this.props;
    var chatPostComponent = currentUserId ? <TournamentChatForm onPostChat={onPostChat} tournamentId={tournament.get("id")} /> : undefined;
    return (
      <div className="chat">
        <ul className="chat_list" ref="chatList">
          <li className="chat_item">
            <div className="chat_avatar">
              <GameManagerAvatar />
            </div>

            <div className="chat_message">
              <div className="chat_name">
                <span>
                  {window.env.brandName}

                  {" "}
                  Game Manager
                </span>
              </div>

              <div className="chat_body">
                Players, welcome to the
                {" "}

                {tournament.get("name")}
                !
              </div>
            </div>
          </li>

          <li className="chat_item">
            <div className="chat_avatar">
              <GameManagerAvatar />
            </div>

            <div className="chat_message">
              <div className="chat_name">
                <span>
                  {window.env.brandName}

                  {" "}
                  Game Manager
                </span>
              </div>

              <div className="chat_body">
                This game chat is for players. Please
                {" "}

                <OpenIntercomLink>
                  contact us
                </OpenIntercomLink>

                {" "}
                if you have any questions. Good Luck!
              </div>
            </div>
          </li>

          {tournamentChats.map((tournamentChat) =>
            <TournamentChatsFeedItem key={tournamentChat.get("id")} tournamentChat={tournamentChat} user={users.get(tournamentChat.get("user_id"))} />
          )}
        </ul>

        {chatPostComponent}
      </div>
    );
  }
}

class TournamentChatForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.postChat = this.postChat.bind(this);
  }

  postChat(e) {
    var { onPostChat, tournamentId } = this.props;
    e.preventDefault();
    let chatMessage = this.refs.chatMessage.value;
    this.refs.chatMessage.value = "";
    onPostChat(chatMessage, tournamentId);
  }

  render() {
    return (
      <div className="chat_form">
        <form onSubmit={this.postChat}>
          <input className="form_input" name="chat-message" placeholder="Type a message..." ref="chatMessage" type="text" />
        </form>
      </div>
    );
  }
}
